import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoint } from '~/styles/themes';

const centerButton = '40px';

export const Container = styled.nav`
  ${({ theme }) => css`
    position: fixed;
    z-index: 10;
    bottom: 0;
    left: 50%;
    width: 100%;
    max-width: ${breakpoint.mobile_large};
    transform: translateX(-50%);
    border-top: 1px solid ${theme.stroke.stroke_1};
    background: ${theme.backgroundColor.base};
    backdrop-filter: blur(25px);
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    height: ${theme.layout.chat_navigation_height};
    gap: 16px;
  `}
`;

export const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: calc((100% - 60px) / 2);
`;

export const MenuBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 100%;
  margin: 0 auto;
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const Title = styled.strong<{ active: boolean }>`
  ${({ theme, active }) => css`
    display: block;
    color: ${active ? theme.content.hierarchy1 : theme.content.caption2};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.1px;
    line-height: 22px;
  `}
`;

export const CenterButtonBox = styled.div`
  display: block;
  position: relative;
  padding: 10px;
`;

export const CenterButton = styled.button<{ isOpen: boolean }>`
  ${({ theme, isOpen }) => css`
    width: ${centerButton};
    height: ${centerButton};
    border-radius: 15px;
    background: ${theme.content.content_light_1};
    text-indent: -9999px;

    &::after {
      content: '';
      display: flex;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 13px;
      height: 2px;
      transform: ${!isOpen
        ? `translate(-50%, -50%)`
        : `translate(-50%, -50%) rotate(45deg)`};
      transition: transform 0.3s ease-in-out;
      border-radius: 2px;
      background: ${theme.backgroundColor.bg_dark_1};
    }

    &::before {
      content: '';
      display: flex;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 2px;
      height: 13px;
      transform: ${!isOpen
        ? `translate(-50%, -50%)`
        : `translate(-50%, -50%) rotate(45deg)`};
      transition: transform 0.3s ease-in-out;
      border-radius: 2px;
      background: ${theme.backgroundColor.bg_dark_1};
    }
  `}
`;
